import { render, staticRenderFns } from "./Requirement.vue?vue&type=template&id=53589097&scoped=true"
import script from "./Requirement.vue?vue&type=script&lang=js"
export * from "./Requirement.vue?vue&type=script&lang=js"
import style0 from "./Requirement.vue?vue&type=style&index=0&id=53589097&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53589097",
  null
  
)

export default component.exports